export default __webpack_public_path__ + "static/media/ad.2ebb6077.jpg";